import React from "react"

import {CustomIconProps} from "./type/CustomIconProps"

export const WarningIcon = ({
    stroke = "#307ADE",
    size = 16,
    fill = "none",
    ...props
}: CustomIconProps): React.ReactNode => {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1V1C11.8663 1 15 4.13367 15 8V8C15 11.8663 11.8663 15 8 15V15C4.13367 15 1 11.8663 1 8V8C1 4.13367 4.13367 1 8 1Z"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M8.00009 8.38889V4.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M7.99932 11.1111C7.89199 11.1111 7.80488 11.1982 7.80565 11.3055C7.80565 11.4128 7.89276 11.5 8.0001 11.5C8.10743 11.5 8.19454 11.4128 8.19454 11.3055C8.19454 11.1982 8.10743 11.1111 7.99932 11.1111"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
